import Header from "@/components/Header";
import Sidebar from "@/components/Sidebar";
import { Flex } from "@chakra-ui/react";

export type AuthenticatedScreenDefinitionProps = {
  children: React.ReactNode;
};

export default function AuthenticatedScreenDefinition({
  children,
}: AuthenticatedScreenDefinitionProps) {
  return (
    <Flex display="flex" flexDir="row" width="100vw" height="100vh" boxSizing="border-box">
      <Sidebar />

        <Flex width="100%" height="100%" flexDir="column">
          <Header />

          <Flex width="100%" height="100%" overflowY="scroll" p="18px" boxSizing="border-box">
            <Flex w="100%" borderRadius="8px">
              {children}
            </Flex>
          </Flex>
        </Flex>
    </Flex>
  );
}
